export default __webpack_public_path__ + "static/media/img-ineligible.425d0a36.png";